export default "/images/vendor/flag-icon-css/flags/1x1/mq.svg?09c19f656772c8f93989b6123655dd91";